// extracted by mini-css-extract-plugin
export default {"ProductInfoWrapper":"_2RxpCnZPwyrJrw-lV1xIHK"};